import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faEye,
    faTrash,
    faTrashAlt,
    faCheckCircle,
    faBolt,
    faCoins,
    faSpellCheck,
    
    //    faCodeBranch
} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import { handleDelete, handleFollowStatus, formDatasource, formPipelinesource, call_get_api} from "../utils/event_handling";
import { ui_service_ip } from "../utils/ip_details";
import { get_edit_component } from "./editComponents";
import ViewContent from "./viewContent";
import Row from 'react-bootstrap/Row';
import TestConnection from '../configure/components/testConnection';
import RcTooltip from 'rc-tooltip';
import { connect } from "react-redux";
import {
    addMLModelMapping,
    setMLModel
} from "../redux/actions";
import { TABLE_DELETE_CLASS, TABLE_EDIT_CLASS, TABLE_VIEW_CLASS } from "../utils/constant";
import { checkPermissions } from '../utils/common_utils';
import { DeleteWarningModal } from "./DeleteWarningModal";
import { EllipsisVertical, SquarePen, Trash, Eye, Cable } from "lucide-react";
import {
    getDatasourceIcon,IncidentToast
} from "../utils/configure_utils";

class EditActions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            test_conn: null,
            disableDelete: false,
            viewbtnDatasourceActions: false,
            showHistoryDropdown: false,
            showIncidentToast: false,
            incidentToastTitle: '',
            incidentToastDescription: '',
            isCreatingDatasource: false,
            saveErrorMessage: '',
            isEditingDatasourceDetails: false,
        }
        // Statuses where deletion IS allowed for auto-config datasources
        this.DELETABLE_AUTO_CONFIG_STATUSES = ['completed', 'failed','configuring_integrations_failed'];
        this.get_edit_component = get_edit_component.bind(this);
        this.formDatasource = formDatasource.bind(this);
        this.formPipelinesource = formPipelinesource.bind(this);
        this.setConnection = this.setConnection.bind(this);
        this.renderActionButton= this.renderActionButton.bind(this);
        this.setPipelineSourceConnection = this.setPipelineSourceConnection.bind(this);
        this.toggleHistoryDropdown = this.toggleHistoryDropdown.bind(this);
        this.dropdownRef = React.createRef();
        this.dropdownButtonRef = React.createRef();
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleCloseIncidentToast = this.handleCloseIncidentToast.bind(this);
        this.isAutoConfig = this.isAutoConfig.bind(this);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentClick);
        window.addEventListener("scroll", this.handleScroll, true);
        window.addEventListener('close-all-dropdowns', this.handleScroll);
        window.addEventListener('save-completed', this.handleSaveCompleted);
        window.addEventListener('datasource-editing-details', this.handleDatasourceEditingDetails);
    }

    handleScroll = () => {
        if (this.state.showHistoryDropdown) {
            this.setState({ showHistoryDropdown: false });
        }
    };

    handleSaveCompleted = (event) => {
        this.setState({
            isCreatingDatasource: false,
            isEditingDatasourceDetails: false,
            saveErrorMessage: event?.detail?.errorMessage || ''
        });
    };

    handleDatasourceEditingDetails = (event) => {
        this.setState({ isEditingDatasourceDetails: event?.detail?.editing === true });
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentClick);
        window.removeEventListener("scroll", this.handleScroll, true);
        window.removeEventListener('close-all-dropdowns', this.handleScroll);
        window.removeEventListener('save-completed', this.handleSaveCompleted);
        window.removeEventListener('datasource-editing-details', this.handleDatasourceEditingDetails);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.setState({ saveErrorMessage: '' });
        }
    }

    handleDocumentClick(event) {
        if (
            this.state.showHistoryDropdown &&
            this.dropdownRef.current &&
            !this.dropdownRef.current.contains(event.target) &&
            this.dropdownButtonRef.current &&
            !this.dropdownButtonRef.current.contains(event.target)
        ) {
            this.setState({ showHistoryDropdown: false });
        }
    }

    toggleHistoryDropdown = () => {
        this.setState((prevState) => ({ showHistoryDropdown: !prevState.showHistoryDropdown }));
    }

    renderActionButton(componentName, onClickFunction, classNameValue,
        
        buttonIconName,
        toolTipContent = null,
        showButtonText = true) {
        /*
         * This function will render the action button with / without tooltip based on the tooltip content
         */


        if (toolTipContent === undefined || toolTipContent === null) {
            return (
                <RcTooltip placement="top"
                    overlay={
                        <span id={'tooltip-top'}>
                            {'View'}
                        </span>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                <button onClick={onClickFunction} type="button"
                    className={classNameValue}>
                    <i>
                        <FontAwesomeIcon icon={buttonIconName} />
                    </i>
                    {showButtonText ? <span>{componentName}</span> : ''}
                </button>
                </RcTooltip>
            );
        }

        // We need to show tooltip since tooltip content is not null
        return (
            <>
                <RcTooltip placement="top"
                    overlay={
                        <span id={'tooltip-top'}>
                            {'View'}
                        </span>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    <button onClick={onClickFunction} type="button"
                        className={classNameValue}>
                        <i>
                            <FontAwesomeIcon icon={buttonIconName} />
                        </i>
                        {showButtonText ? <span>{componentName}</span> : ''}
                    </button>
                </RcTooltip>
            </>
        );
    }

    getFormattedKeys(){
       switch(this.props.component){
          case "Datasource" || "configuredDatasourcesAdvanced":
                return ["Created Time","Datastore Type","Schema Learning Status","Environment Name",
                        "Datasource Name","Datasource Type"]
          case "Model":
                return ["Author","Created Time","Environment Name","Datasource Name","Model Type",
                        "ML Stack","Model Name","Modified Time","Version"]
          case "Metric":
                return ["Created Time","Dataset Name","Metric Name","Formula","Next Run Time",
                        "Schedule Interval"]
          case "Alert":
                return ["Alert Name","Alert Period","Alert Type","Configured Notifications",
                        "Created Time","Alert If","Configured Pipeline Channels"]
          case "Notification Channel":
               return ["Configuration","Notification Name","Created Time","Modified Time"]
          case "Pipeline":
               return ["Configuration","Created Time","Modified Time","Pipeline Channel Name"]
          case "pipelinesource":
                return ["Created Time","Datastore Type","Pipeline Status","Environment Name",
                        "Datasource Name","Datasource Type"]
          default:
              return ''
       }
    }

    loadViewDetails() {
        if (this === undefined || this.props.view_details === undefined) {
            return;
        }

        const details = this.props.view_details;
        const divItems = [];
        let FormattedKeys = this.getFormattedKeys()
        let i = 0
        Object.keys(details).forEach(function (key) {
            let value;
            if (typeof (details[key]) == 'object') {
                value = JSON.stringify(details[key]);
            }
            else {
                value = details[key];
            }
            if (!(["metric_type", "key", "status_code", "checks", "status_text", "pipeline_trigger_type", "consume_group_type", "hide_edit", "auth_config", "integration_config", "features", "model_details"].includes(key)) && key.endsWith("_id") !== true) {
                divItems.push(
                    <div key={key} className="col-md-10 offset-md-1">
                        <div className="form-group row">
                            <label className="col-md-5 text-md-right">{FormattedKeys[i++]} :</label>
                            <div className="col-md-7 text-muted text-break">
                                <span>{value}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        });
        return divItems;
    }

    setConnection() {
        let test_conn_data = this.props.view_details;
        test_conn_data["is_config_details"] = false;
        this.formDatasource(this.props.view_details);
        this.props.ConnectionShow();

    }
    setPipelineSourceConnection() {
        let test_conn_data = this.props.view_details;
        test_conn_data["is_config_details"] = false;
        this.formPipelinesource(this.props.view_details);
        this.props.ConnectionShow();

    }

    handleShowIncidentToast(title, description) {
        this.setState({
            showIncidentToast: true,
            incidentToastTitle: title,
            incidentToastDescription: description
        });
    }

    handleCloseIncidentToast() {
        this.setState({ showIncidentToast: false });
    }

    isAutoConfig() {
        if (this.props.component !== "Datasource") return false;

        const details = this.props.view_details;
        if (!details) return false;

        const mode = details.mode || details.integration_mode || details.configurationMode || details.config_mode || details.datasource_config?.mode;
        if (mode && (String(mode).toLowerCase() === 'autoconfig' || String(mode).toLowerCase() === 'auto_config' || String(mode).toLowerCase() === 'autoconfigurations')) {
            return true;
        }
        if (details.is_auto_config === true || details.is_autoconfig === true || details.auto_config === true) {
            return true;
        }
        if (details.auto_config_type || details.datasource_config?.auto_config_type) {
            return true;
        }
        if (details.auto_config_status !== undefined && details.auto_config_status !== null && details.auto_config_status !== '') {
            return true;
        }
        return false;
    }

    handleDatasourceAction(action) {
        const isEditAction = action === "edit";
        const teamId = localStorage.getItem('team_id');
        const userId = localStorage.getItem('user_id');

        const showAction = () => {
            this.setState({ showHistoryDropdown: false });
            if (isEditAction) {
                this.props.handleShow();
                this.props.setAddDS(false);
            } else {
                this.props.deleteShow();
            }
        };

        const checkDatasourceStatus = () => {
            let datasourceId;
            let environmentId;

            if (this.props.component === "Datasource") {
                const allDataSources = this.props.allDataSourcesList || [];
                const integrationDatasourceName = this.props.view_details.datasource_name;
                const parentDatasource = allDataSources.find(
                    datasource => datasource.datasource_name === integrationDatasourceName
                );
                datasourceId = parentDatasource?.datasource_id;
                environmentId = parentDatasource?.env_id;
            } else {
                datasourceId = this.props.view_details.datasource_id;
                environmentId = this.props.view_details.env_id;
            }

            if (!datasourceId) {
                showAction();
                return;
            }

            call_get_api(ui_service_ip, "/datasource", {
                user_id: userId,
                env_id: environmentId,
                tenant_id: teamId,
                datasource_id: datasourceId
            }).then(response => {
                if (response?.datasource?.auto_config_status) {
                    const rawStatus = response.datasource.auto_config_status;
                    if (this.props.onAutoConfigStatusUpdate) {
                        this.props.onAutoConfigStatusUpdate(datasourceId, rawStatus);
                    }
                    const autoConfigStatus = rawStatus.toLowerCase().replace(/ /g, '_');
                    if (!this.DELETABLE_AUTO_CONFIG_STATUSES.includes(autoConfigStatus)) {
                        this.handleShowIncidentToast(
                            isEditAction ? "Editing not allowed" : "Deleting not allowed",
                            "Auto config is still in progress."
                        );
                        return;
                    }
                }
                showAction();
            });
        };

        if (this.props.component !== "Datasource") {
            checkDatasourceStatus();
            return;
        }

        const integrationId = this.props.view_details?.integration_id;
        if (!integrationId) {
            checkDatasourceStatus();
            return;
        }

        call_get_api(ui_service_ip, "/integration", {
            integration_id: integrationId,
            tenant_id: teamId
        }).then(response => {
            const integrationMode = response?.integration?.mode;
            if (String(integrationMode).toLowerCase() === "autoconfig") {
                this.handleShowIncidentToast(
                    isEditAction ? "Editing not allowed" : "Deleting not allowed",
                    isEditAction
                        ? "Auto config mode does'nt have the options to edit"
                        : "Auto config mode does'nt have the options to delete"
                );
                return;
            }
            checkDatasourceStatus();
        });
    }

    render() {
        // Currently we will be showing View and Edit button with tooltip warning messages,
        // if any warning messages are to be shown

        const isModel = this.props.component === "Model";
        let showButtonText = isModel ? false : true;
        let viewTooltip = isModel ? "View" : this.props.tooltipContent;
        let editTooltip = isModel ? "Edit" : this.props.tooltipContent;

        let disableConfigureAction = checkPermissions('Configure')
        let disableAlertAction = checkPermissions('Alerts')
        let disableMetricsAction = checkPermissions('Metrics')

        // Check if this is the only integration belonging to its parent datasource.
        // allIntegrationsList is the full table data { headers, data: [ row[] ] } passed from configure/index.
        // Each row's last cell has an integration_data object with datasource_name.
        let isLastIntegration = false;
        if (this.props.component === "Datasource") {
            const currentDatasourceName = this.props.view_details && this.props.view_details.datasource_name;
            const tableRows = this.props.allIntegrationsList && this.props.allIntegrationsList.data;
            if (currentDatasourceName && Array.isArray(tableRows)) {
                const siblingCount = tableRows.filter(row => {
                    const actionCell = row[row.length - 1];
                    return actionCell && actionCell.integration_data &&
                        actionCell.integration_data.datasource_name === currentDatasourceName;
                }).length;
                isLastIntegration = siblingCount === 1;
            }
        }
        return (
            <>
            <IncidentToast
                show={this.state.showIncidentToast}
                onClose={this.handleCloseIncidentToast}
                title={this.state.incidentToastTitle}
                description={this.state.incidentToastDescription}
            />
            {this.props.component === "Datasource" || this.props.component === "configuredDatasourcesAdvanced" ?
                <>
                 <div className="tw-relative tw-flex tw-items-center tw-gap-2">
                                            <button
                                              onClick={() => {
                                                   this.props.component === "configuredDatasourcesAdvanced" ?
                                                  this.props.testConnectionDataSource(this.props.view_details) :
                                                  this.props.testConnectionIntegration(this.props.view_details);

                                            }}
                                className="tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pointer tw-bg-white tw-px-3 tw-py-[5px] tw-leading-5 tw-border tw-border-solid tw-border-[#D5D7DA] tw-text-[#414651] tw-font-medium hover:tw-bg-[#F5F5F5]">
                                                <RcTooltip
                                                    placement="top"
                                                    overlay={<span>Test Connection</span>}
                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                >
                                                    <Cable size={16} color="#A4A7AE" />
                                                </RcTooltip>
                                                Test
                                            </button>

                                            <RcTooltip
                                                placement="top"
                                                overlay={<span>More</span>}
                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                            >
                                                <button
                                                    ref={this.dropdownButtonRef}
                                                    className='tw-p-1 tw-bg-transparent tw-border-0 tw-rounded tw-pointer-events-auto hover:tw-bg-[#F5F5F5] tw-transition-all tw-duration-300 tw-ease-in-out'
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        this.setState(prev => ({ showHistoryDropdown: !prev.showHistoryDropdown }));
                                                    }}
                                                >
                                                    <EllipsisVertical size={14} color="#A4A7AE" />
                                                </button>
                                            </RcTooltip>
                                            {/* Dropdown Menu */}
                                            {this.state.showHistoryDropdown && ReactDOM.createPortal(
                                                <ul
                                                    ref={this.dropdownRef}
                                                    style={{
                                                        position: 'fixed',
                                                        top: (this.dropdownButtonRef.current?.getBoundingClientRect().bottom || 0) + 4,
                                                        left: (this.dropdownButtonRef.current?.getBoundingClientRect().right || 0) - 180,
                                                        minWidth: 180,
                                                        background: '#fff',
                                                        borderRadius: 8,
                                                        padding: '4px 0',
                                                        border: '1px solid #E9EAEB',
                                                        overflow: 'hidden',
                                                        zIndex: 9999,
                                                        boxShadow: '0px 2px 2px 1px rgba(164,167,174,0.04),0px 4px 6px -2px rgba(164,167,174,0.03),0px 12px 16px -4px rgba(164,167,174,0.08)'
                                                    }}
                                                    className="custom-dropdown-menu"
                                                >
                                                    
                                                     
                                                    <li>
                                                        <button className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-bg-transparent tw-border-0  tw-py-2 tw-px-4 hover:tw-bg-[#F5F5F5]"
                                                         onClick={(e) => {
                                                                  this.setState({ showHistoryDropdown: false });
                                                                if (this.props.component === "Datasource") {
                                                                    this.props.handleShow();
                                                                    this.props.setAddDS(false)
                                                                    this.setState({viewbtnDatasourceActions:true})

                                                                } else if (this.props.component === "configuredDatasourcesAdvanced") {
                                                                    this.props.handleShow();
                                                                    this.props.setAddDS(false)
                                                                    this.setState({viewbtnDatasourceActions:true})
                                                                }else{
                                                                this.props.viewShow();
                                                                }
                                                            }}
                                                        >
                                                            <Eye size={16} color="#A4A7AE" />
                                                            <span className="tw-text-sm tw-font-medium tw-text-[#414651]">View Details</span>
                                                        </button>
                                                    </li> 

                                                     {(this.props.component === "Datasource" ) || this.props.component === "configuredDatasourcesAdvanced" ?
                                                        (this.isAutoConfig() ?
                                                            <RcTooltip placement="top"
                                                                overlay={
                                                                    <span id={'tooltip-top'}>
                                                                        {"Auto-config integrations can't be edited"}
                                                                    </span>
                                                                }
                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                            >
                                                                <li className="tw-cursor-not-allowed" style={{ cursor: 'not-allowed' }}>
                                                                    <button
                                                                        disabled={true}
                                                                        onClick={(e) => e.preventDefault()}
                                                                        style={{ cursor: 'not-allowed', pointerEvents: 'none' }}
                                                                        className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-bg-transparent tw-border-0 tw-py-2 tw-px-4 tw-opacity-50 tw-cursor-not-allowed"
                                                                    >
                                                                        <SquarePen size={16} color="#A4A7AE" />
                                                                        <span className="tw-text-sm tw-font-medium tw-text-[#414651]">Edit Configuration</span>
                                                                    </button>
                                                                </li>
                                                            </RcTooltip>
                                                            :
                                                            <li 
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.handleDatasourceAction("edit");
                                                                }}
                                                            >
                                                                <button className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-bg-transparent tw-border-0 tw-py-2 tw-px-4 hover:tw-bg-[#F5F5F5]">
                                                                    <SquarePen size={16} color="#A4A7AE" />
                                                                    <span className="tw-text-sm tw-font-medium tw-text-[#414651]">Edit Configuration</span>
                                                                </button>
                                                            </li>
                                                        ) : "" }

                                                     {(this.props.component === "Datasource" ) || this.props.component === "configuredDatasourcesAdvanced" ?
                                                        (this.isAutoConfig() ?
                                                            <RcTooltip placement="top"
                                                                overlay={
                                                                    <span id={'tooltip-top'}>
                                                                        {"Auto-config integrations can't be deleted"}
                                                                    </span>
                                                                }
                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                            >
                                                                <li className="tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] tw-cursor-not-allowed" style={{ borderTop: '1px solid #E9EAEB', cursor: 'not-allowed' }}>
                                                                    <button 
                                                                        disabled={true}
                                                                        onClick={(e) => e.preventDefault()}
                                                                        style={{ cursor: 'not-allowed', pointerEvents: 'none' }}
                                                                        className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-bg-transparent tw-border-0 tw-py-2 tw-px-4 tw-opacity-50 tw-cursor-not-allowed"
                                                                    >
                                                                        <Trash size={16} color="#F97066" />
                                                                        <span className="tw-text-sm tw-font-medium tw-text-[#F97066]">Delete</span>
                                                                    </button>
                                                                </li>
                                                            </RcTooltip>
                                                            :
                                                            <li className="tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB]" style={{ borderTop: '1px solid #E9EAEB' }}>
                                                                <button 
                                                                    //disabled={disableConfigureAction} 
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.handleDatasourceAction("delete");
                                                                    }}

                                                                    className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-bg-transparent tw-border-0 tw-py-2 tw-px-4 hover:tw-bg-[#F5F5F5]">
                                                                    <Trash size={16} color="#F97066" />
                                                                    <span className="tw-text-sm tw-font-medium tw-text-[#F97066]">Delete</span>
                                                                </button>
                                                            </li>
                                                        ) : ""}
                                                </ul>,
                                                document.body
                                            )}
                                        </div>
                </>:
            <>

                {(viewTooltip === undefined || viewTooltip === null) ?
                <RcTooltip placement="top"
                    overlay={
                        <span id={'tooltip-top'}>
                            {'View'}
                        </span>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    <button
                        // disabled={disableConfigureAction}
                        onClick={(e) => {
                            // e.preventDefault();
                            // this.props.viewShow();
                            // this.props.component === "Datasource" && this.props.setAddDS(false)
                            // this.props.component === "configuredDatasourcesAdvanced" && this.props.setAddDS(false)

if (this.props.component === "Datasource") {
                                this.props.handleShow();
                                this.props.setAddDS(false)
                                this.setState({viewbtnDatasourceActions:true})

                            } else if (this.props.component === "configuredDatasourcesAdvanced") {
                                this.props.handleShow();
                                this.props.setAddDS(false)
                                this.setState({viewbtnDatasourceActions:true})
                               // this.props.viewAction(true);
                            }else{
                              this.props.viewShow();
                            }

                        }}
                        type="button"
                        className={TABLE_VIEW_CLASS}>
                        <i>
                            <FontAwesomeIcon icon={faEye} />
                        </i>
                        {showButtonText ? <span>{"View"}</span> : ''}
                    </button>
                    </RcTooltip>
                    : <RcTooltip placement="top"
                    overlay={
                        <span id={'tooltip-top'}>
                            {'View'}
                        </span>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    <button
                        // disabled={disableConfigureAction}
                        onClick={(e) => {
                            e.preventDefault();
                            if (this.props.component === "Datasource") {
                            this.props.handleShow();
                            this.props.setAddDS(false)
                            this.setState({viewbtnDatasourceActions:true})
                            } else if (this.props.component === "configuredDatasourcesAdvanced") {
                                this.props.handleShow();
                                this.props.setAddDS(false)
                                this.setState({viewbtnDatasourceActions:true})
                            }else{
                              this.props.viewShow();
                            }
                        }}
                        type="button"
                        className={TABLE_VIEW_CLASS}>
                        <i>
                            <FontAwesomeIcon icon={faEye} />
                        </i>
                        {showButtonText ? <span>{"View"}</span> : ''}
                    </button>
                    </RcTooltip>}
              
                {(editTooltip === undefined || editTooltip === null) ?
                <RcTooltip placement="top"
                    overlay={
                        <span id={'tooltip-top'}>
                            {'Edit'}
                        </span>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    
                    <button
                        disabled={disableConfigureAction}
                        onClick={(e) => {
                            e.preventDefault();
                            this.props.handleShow();
                            this.props.component === "Datasource" && this.props.setAddDS(false)
                            this.props.component === "configuredDatasourcesAdvanced" && this.props.setAddDS(false)
                        }}
                        type="button"
                        className={TABLE_EDIT_CLASS}>
                        <i>
                            <FontAwesomeIcon icon={faEdit} />
                        </i>
                        {showButtonText ? <span>{"Edit"}</span> : ''}
                    </button>
                    </RcTooltip>

                    :

                    <RcTooltip placement="top"
                        overlay={
                            <span id={'tooltip-top'}>
                                {'Edit'}
                            </span>
                        }
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                    >
                        <button
                            disabled={disableConfigureAction}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.handleShow();
                            }}
                            type="button"
                            className={TABLE_EDIT_CLASS}>
                            <i>
                                <FontAwesomeIcon icon={faEdit} />
                            </i>
                            {showButtonText ? <span>{"Edit"}</span> : ''}
                        </button>
                    </RcTooltip>

                }


                <RcTooltip placement="top"
                    overlay={
                        <span id={'tooltip-top'}>
                            {'Delete'}
                        </span>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    <button disabled={disableConfigureAction} onClick={this.props.deleteShow} type="button"
                        className={TABLE_DELETE_CLASS}>
                        <i>
                            <FontAwesomeIcon icon={faTrash} />
                        </i>
                        {showButtonText ? <span>{"Delete"}</span> : ''}
                    </button>
                </RcTooltip>
                {
                    this.props.component === "Datasource" ?
                    <RcTooltip placement="top"
                        overlay={
                            <span id={'tooltip-top'}>
                                {'Test Connection'}
                            </span>
                        }
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                    >
                        <button type="button"
                            //onClick={this.setConnection}
                            onClick={() => {
                                this.props.testConnectionIntegration(this.props.view_details);
                            }}
                            className="btn btn-sm btn-outline-dark mr-1">
                            <i><FontAwesomeIcon icon={faCheckCircle} /></i>
                            <span>Test Connection</span>
                        </button>
                    </RcTooltip>
                        :
                        ''
                }


                 {
                    this.props.component === "configuredDatasourcesAdvanced" ?
                    <RcTooltip placement="top"
                        overlay={
                            <span id={'tooltip-top'}>
                                {'Test Connection'}
                            </span>
                        }
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                    >
                        <button type="button"
                            onClick={() => {
                                this.props.testConnectionDataSource(this.props.view_details);
                                // this.setConnection();
                                // this.props.handleShow();
                            }}
                            className="btn btn-sm btn-outline-dark mr-1">
                            <i><FontAwesomeIcon icon={faCheckCircle} /></i>
                            <span>Test Connection</span>
                        </button>
                    </RcTooltip>
                        :
                        ''
                }
                
            {
                    this.props.component === "Pipeline source" ?
                        <button type="button"
                                onClick={this.setPipelineSourceConnection}
                                className="btn btn-sm btn-outline-dark mr-1">
                            <i><FontAwesomeIcon icon={faCheckCircle}/></i>
                            <span>Test Connection</span>
                        </button>
                        :
                        ''
                }

                {this.props.followComponent !== undefined ?
                   
                    <div className="custom-control custom-switch custom-switch-sm">
                        <input type="checkbox"
                            checked={this.props.followStatus}
                            onChange={handleFollowStatus.bind(this, this.props,
                                this.props.followComponent,
                                this.props.followStatus,
                                this.props.updateFollowStatus)
                            }
                            disabled={disableMetricsAction}
                            className="custom-control-input"
                            id={this.props.view_details.key} />
                        <label className="custom-control-label" htmlFor={this.props.view_details.key} />
                    </div>
                    :
                    ''
                }

                {this.props.component === "Pipeline Channel" ?
                    <>
                        <button disabled={disableAlertAction} type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                let details = this.props.view_details;
                                localStorage.setItem('pipelineTriggerName', details.pipeline_trigger_name);
                                localStorage.setItem('pipelineTriggerType', details.pipeline_trigger_type);
                                localStorage.setItem('pipelineTriggerId', details.pipeline_trigger_id);
                                this.props.changeTab("alert", "dq")
                            }}
                            className="btn btn-sm btn-outline-purple mr-1"><i><FontAwesomeIcon icon={faBolt} /></i>
                            <span>DQ Alert</span></button>
                        {this.props.hideModelAlertsTab ? "" : <button type="button" onClick={(e) => {
                            e.preventDefault();
                            let details = this.props.view_details;
                            localStorage.setItem('pipelineTriggerName', details.pipeline_trigger_name);
                            localStorage.setItem('pipelineTriggerType', details.pipeline_trigger_type);
                            localStorage.setItem('pipelineTriggerId', details.pipeline_trigger_id);
                            this.props.changeTab("alert", "ml")
                        }}
                            className="btn btn-sm btn-outline-brown mr-1"><i><FontAwesomeIcon icon={faCoins} /></i>
                            <span>Model Alert</span></button>}
                    </>
                    : ''
                }

                {
                    // For Create Model AB configuration button in ML Models table
                    this.props.modelABState === undefined ?
                        '' :
                        <RcTooltip placement="top"
                            overlay={
                                <span id={'tooltip-top'}>
                                    {'Create Model AB Test'}
                                </span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                        >
                            <button onClick={this.props.modelABShow} type="button"
                                className="btn btn-sm btn-outline-info mr-1">
                                <i>
                                    <FontAwesomeIcon icon={faSpellCheck} />
                                </i>
                                <span />
                            </button>
                        </RcTooltip>

                }
            </> 
             }

 <Modal show={this.props.view} size="xl" centered onHide={this.props.viewClose}>
                    <Modal.Header closeButton>
                        <h5 className="modal-title" id="exampleModalLongTitle">
                            {this.props.component==="configuredDatasourcesAdvanced" ? 
                            'View Datasource Details':
                            (this.props.modalTitle !== undefined ? `${this.props.modalTitle} Details` : `${this.props.component} Details`) }
                        </h5>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="py-3">
                            {<ViewContent component={this.props.component} viewDetails={this.props.view_details} />}
                        </Row>
                    </Modal.Body>
                </Modal>
                <Modal show={this.props.connection_show} size="lg" centered onClick={this.props.updateTable} onHide={this.props.connectionClose}>
                    <Modal.Header closeButton>
                        <h5 className="modal-title" id="exampleModalLongTitle">
                            Test Connection
                        </h5>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="py-3">
                            {<TestConnection testConnection_data={this.state.test_conn} testConnection={true} />}
                        </Row>
                    </Modal.Body>
                </Modal>

                <Modal show={this.props.canShowDelWarning} centered onHide={this.props.closeDeleteWarning}>
                    <Modal.Header closeButton className="d-none">
                        <h5 className="modal-title" id="modelDeleteWarningForAB">
                            Model Delete
                        </h5>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="modal__alert">
                            <div className="modal_alert-icon">
                                <i className="text-danger">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </i>
                            </div>

                            <div className="modal_alert-text">
                                <h4>You have Model AB tests configured for the selected model</h4>
                                <p>Please delete the model AB configurations which use this model
                                    before trying to delete it</p>
                            </div>

                            <div className="modal_alert-btn-group">
                                <button type="button" onClick={this.props.closeDeleteWarning}
                                    className="btn btn-outline btn-grey btn-circle mr-2">Close
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <DeleteWarningModal delete_show={this.props.delete_show}
                    deleteClose={this.props.deleteClose}
                    modalTitle={this.props.modalTitle}
                    component={this.props.component}
                    disableDelete={this.state.disableDelete}
                    datasourceDetails={this.props.view_details}
                    integration_id={this.props.integration_id}
                    isLastIntegration={isLastIntegration}
                    handleDeleteFunction={handleDelete.bind(this, this.props,
                        this.props.delete_component,
                        this.props.deleteClose)}
                >
                </DeleteWarningModal>

{this.props.component === "configuredDatasourcesAdvanced" || this.props.component === "Datasource" ?

                 <Modal show={this.props.show} dialogClassName="modal-vertical shadow" className="fixed-right model__help modal-integration" size="xl" onHide={() => {this.props.handleClose(); this.setState({viewbtnDatasourceActions:false, saveErrorMessage: '', isEditingDatasourceDetails: false})}} centered>
                                    {/* <Modal.Header className="modal-header !tw-px-6 !tw-py-3 align-items-center text-white" closeButton>
                                        <div>
                                            <h4 className="tw-text-[18px] tw-font-semibold tw-text-[#212229] tw-flex tw-items-center tw-mb-1">
                                                <span className="tw-text-[#717680] tw-me-2">{this.state.viewbtnDatasourceActions ? "Viewing" : "Editing"} Datasource:</span>{this.props.view_details.datasource_name}
                                            </h4>
                                            <p className="tw-text-sm tw-text-[#535862] tw-mb-0">Update your Integration configuration</p>
                                        </div>
                                    </Modal.Header> */}

                        <Modal.Header className="!tw-px-6 !tw-py-3 align-items-center" closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/20 tw-bg-white dark:tw-bg-white/10 tw-rounded-[10px]'>
                                {this.state.viewbtnDatasourceActions ? 
                                <Eye size={20} color="currentColor" className="tw-text-[#414651] dark:tw-text-white" /> : 
                                <SquarePen size={20} color="currentColor" className="tw-text-[#414651] dark:tw-text-white" /> }
                            </div>
                            <div>
                                <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">{this.state.viewbtnDatasourceActions ? "View" : "Edit"} {this.props.component === "Datasource" ? "Integration" : "Datasource"}</h5>
                                <div className='tw-flex tw-items-center tw-gap-2'>
                                    <div className='tw-px-2 tw-py-[2px] tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-medium tw-text-[#175CD3] dark:!tw-text-white tw-border tw-border-solid tw-border-[#B2DDFF] dark:!tw-border-white/30 dark:!tw-bg-white/10 tw-rounded-[6px] tw-uppercase' onClick={this.handleRefreshSchemas}>
                                        {getDatasourceIcon(this.props.view_details.connector_type)}
                                        {" "+this.props.view_details.connector_type}
                                    </div>
                                    <strong className='tw-text-sm tw-text-[#535862] dark:!tw-text-white !tw-font-medium tw-ms-1'>{this.props.view_details.datasource_name}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>

                                    <Modal.Body className="tw-overflow-x-hidden">
                                       {this.get_edit_component(this.props,this.state.viewbtnDatasourceActions)}
                                    </Modal.Body>
                                    <Modal.Footer className='justify-content-between'>
                                        <div className="tw-max-w-[60%] tw-text-left" aria-live="polite">
                                            {this.state.saveErrorMessage && (
                                                <span role="alert" className="tw-text-xs tw-font-medium tw-text-[#DC2626]">
                                                    {this.state.saveErrorMessage}
                                                </span>
                                            )}
                                        </div>
                                        <div>
                                            <button className="btn btn-outline btn-grey tw-mr-3" onClick={() => {this.props.handleClose(); this.setState({viewbtnDatasourceActions:false, saveErrorMessage: '', isEditingDatasourceDetails: false})}}>Cancel</button>
                                           {this.state.viewbtnDatasourceActions ?   
                                             "" : <button type="button" className="btn btn-primary" disabled={this.state.isCreatingDatasource || this.state.isEditingDatasourceDetails} onClick={() => {
                                                this.setState({ isCreatingDatasource: true, saveErrorMessage: '' }, () => {
                                                    window.dispatchEvent(new Event('trigger-datasource-save'));
                                                    window.dispatchEvent(new Event('trigger-integration-save'));
                                                });
                                             }}>
                                                {this.state.isCreatingDatasource ? (
                                                    <div className="tw-flex tw-items-center tw-justify-center">
                                                        <div className="tw-w-[14px] tw-h-[14px] tw-border tw-border-solid tw-rounded-full tw-border-white tw-border-t-transparent tw-animate-spin"></div>
                                                        <span className='tw-ml-2'>Saving...</span>
                                                    </div>
                                                ) : "Save Changes"}
                                            </button> }
                                        </div>
                                    </Modal.Footer>
                                </Modal>
:

                    <Modal show={this.props.show} size="xl" centered onHide={() => { this.props.handleClose(); this.setState({ saveErrorMessage: '' }); }}>
                    <Modal.Header closeButton>
                        <h5 className="modal-title" id="exampleModalLongTitle">
                            {this.props.modalTitle !== undefined ? `Edit ${this.props.modalTitle} Details` : `Edit ${this.props.component}`}
                        </h5>
                    </Modal.Header>
                    <Modal.Body>
                        {this.get_edit_component(this.props)}
                    </Modal.Body>
                </Modal>
    }

                {/* Model AB Configuration model*/}
                {this.props.modelABState ?
                    this.props.showModelABPopup(this.props, this.props.modelABState,
                        this.props.modelABClose, this.props.handleModelABAddition) :
                    ''
                }

                <Modal show={this.props.modelVersionState}
                    size="xl"
                    centered onHide={this.props.modelVersionClose}>

                    <Modal.Header closeButton>
                        <h5 className="modal-title" id="modelVersionCreation">
                            Model Version
                        </h5>
                    </Modal.Header>
                    <Modal.Body>
                        {/*{this.get_edit_component(this.props)}*/}
                    </Modal.Body>
                </Modal>
          </>
        
        );
   }

}
//export default EditActions;
const mapStateToProps = state => {
    return state;
}

export default connect(
    mapStateToProps, {
    addMLModelMapping,
    setMLModel
}
)(EditActions);
